/**
 * @description Settings for training videos controller
 * @module API controller / Training Videos
 */
module.exports = {
  trackVideo: {
    /**
     * @description Request dashboard video tracking
     * @param {number} accountId
     * @returns {object} request settings
     */
    settings: ({ accountId, videoName }) => {
      return {
        endpoint: '/ahoy/visits',
        body: {
          accountId,
          event: 'viewed_dashboard_video',
          videoName,
        },
        method: 'POST',
      }
    },
  },

  trackSpiderGraph: {
    /**
     * @description Request spider graph tracking
     * @param {number} accountId
     * @returns {object} request settings
     */
    settings: ({ accountId, teamId }) => ({
      endpoint: '/ahoy/visits',
      body: {
        accountId,
        event: 'generated_spider_graph',
        teamId,
      },
      method: 'POST',
    }),
  },

  trackNetworkRevealColleagueClicked: {
    /**
     * @description Track when a user clicks a colleague card on the E2 Network Reveal interstitial step
     * @param {number} accountId
     * @param {number} colleagueProfileId - profile ID of the clicked colleague
     * @returns {object} request settings
     */
    settings: ({ accountId, colleagueProfileId }) => ({
      endpoint: '/ahoy/visits',
      body: {
        accountId,
        event: 'network_reveal_colleague_clicked',
        colleagueProfileId,
      },
      method: 'POST',
    }),
  },

  trackPairReportCtaClicked: {
    /**
     * @description Track when a user clicks "View Pair Report" on the E3c interstitial step
     * @param {number} accountId
     * @param {number} colleagueProfileId - profile ID of the selected colleague
     * @returns {object} request settings
     */
    settings: ({ accountId, colleagueProfileId }) => ({
      endpoint: '/ahoy/visits',
      body: {
        accountId,
        event: 'pair_report_cta_clicked',
        colleagueProfileId,
        source: 'interstitial',
      },
      method: 'POST',
    }),
  },

  trackPairReportColleagueChanged: {
    /**
     * @description Track when a user swaps to a different colleague on the E3c interstitial step
     * @param {number} accountId
     * @param {number} newColleagueProfileId - profile ID of the newly selected colleague
     * @returns {object} request settings
     */
    settings: ({ accountId, newColleagueProfileId }) => ({
      endpoint: '/ahoy/visits',
      body: {
        accountId,
        event: 'pair_report_colleague_changed',
        newColleagueProfileId,
      },
      method: 'POST',
    }),
  },
}
